import { useEffect, useState } from 'react';

export function useMobileLayout({
	containerRef,
	shiftToMobile,
}: {
	shiftToMobile?: (width: number) => boolean;
	containerRef: React.RefObject<HTMLDivElement>;
}) {
	const [isMobileLayout, setIsMobileLayout] = useState(false);
	useEffect(() => {
		const container = containerRef.current;
		if (container) {
			const handler = (entries: ResizeObserverEntry[]) => {
				setIsMobileLayout(shiftToMobile?.(entries[0].contentRect.width) || false);
			};
			const observer = new ResizeObserver(handler);

			observer.observe(container);
			return () => {
				observer.unobserve(container);
			};
		}
	}, [containerRef, shiftToMobile]);

	return {
		isMobileLayout,
	};
}
